import classNames from 'classnames';
import React from 'react';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';
import Button from './Button';
import * as styles from './EntityPill.module.scss';
import SVGIcon from './SVGIcon';
import Tooltip from './Tooltip';
import Link from '../utils/router/Link';

interface EntityPillProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  to?: React.ComponentProps<typeof Link>['to'];
  type?: 'post' | 'group' | 'user' | 'userFocused' | 'topic';
  onRemove?: React.MouseEventHandler;
  tooltip?: string;
}

const EntityPill = ({
  children,
  icon = null,
  onRemove,
  to,
  type,
  tooltip,
}: EntityPillProps) => {
  const className = classNames(styles.pill, type && styles[type]);
  const inner = (
    <>
      {!!icon && (
        <div className={styles.iconContainer} aria-label="icon">
          {icon}
        </div>
      )}
      {children}
      {onRemove && (
        <Button className={styles.remove} onClick={onRemove}>
          <SVGIcon size={10}>{clearIcon}</SVGIcon>
        </Button>
      )}
    </>
  );

  const content =
    onRemove || !to ? (
      <div className={className}>{inner}</div>
    ) : (
      <Link to={to} className={className}>
        {inner}
      </Link>
    );

  if (!tooltip) {
    return content;
  }

  return <Tooltip content={tooltip}>{content}</Tooltip>;
};

export default EntityPill;
